const AgentTool = {
  browser: function () {
    var browser = {};
    var version = "";
    var s;
    var userAgent = navigator.userAgent.toLowerCase();
    (s = userAgent.match(/msie ([\d.]+)/)) ? browser.ie = s[1] : (s = userAgent.match(/firefox\/([\d.]+)/)) ? browser.firefox = s[1] : (s = userAgent.match(/chrome\/([\d.]+)/)) ? browser.chrome = s[1] : (s = userAgent.match(/opera.([\d.]+)/)) ? browser.opera = s[1] : (s = userAgent.match(/version\/([\d.]+).*safari/)) ? browser.safari = s[1] : 0;
    if (browser.ie) {
      version = 'IE ' + browser.ie;
    }
    else {
      if (browser.firefox) {
        version = 'firefox ' + browser.firefox;
      }
      else {
        if (browser.chrome) {
          version = 'chrome ' + browser.chrome;
        }
        else {
          if (browser.opera) {
            version = 'opera ' + browser.opera;
          }
          else {
            if (browser.safari) {
              version = 'safari ' + browser.safari;
            }
            else {
              version = 'other';
            }
          }
        }
      }
    }
    return version;
  },
  clientOs: function () {
    var sUserAgent = navigator.userAgent.toLowerCase();
    var isWin = (navigator.platform == "Win32") || (navigator.platform == "Win64") || (navigator.platform == "wow64");
    var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
    var isIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var isIpad = sUserAgent.match(/ipad/i) == "ipad";
    var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
    if (isUnix) return "unix";
    var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
    var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
    if (isLinux) {
      if (bIsAndroid) return "android";
      else return "linux";
    }
    if (isIphoneOs) {
      return "iphone os";
    }
    if (isIpad) {
      return "ipad";
    }
    if (isMac) {
      return "macos";
    }
    if (isWin) {
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (bIsWM) {
        return "windows mobile";
      }
      return "windows";
    }

    return "other";
  },

}

export default AgentTool;



// WEBPACK FOOTER //
// ./utils/client.js